import { type InputHTMLAttributes, forwardRef } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
  fullWidth?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, icon, iconRight, fullWidth = true, className = "", ...props }, ref) => {
    return (
      <div className={`${fullWidth ? "w-full" : ""}`}>
        {label && (
          <label className="block text-sm font-medium text-foreground-700 mb-1.5">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 flex items-center justify-center w-4 h-4">
              {icon}
            </span>
          )}
          <input
            ref={ref}
            className={`w-full text-sm rounded-lg border-2 bg-background-50 text-foreground-900 placeholder:text-foreground-400 transition-all duration-150
              ${icon ? "pl-10" : "pl-3.5"} ${iconRight ? "pr-10" : "pr-3.5"} py-2.5
              ${error
                ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                : "border-background-300 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              }
              disabled:bg-background-100 disabled:text-foreground-400 disabled:cursor-not-allowed
              ${className}`}
            {...props}
          />
          {iconRight && (
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 flex items-center justify-center w-4 h-4">
              {iconRight}
            </span>
          )}
        </div>
        {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
        {helperText && !error && (
          <p className="mt-1 text-xs text-foreground-500">{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;